import { getInitialResourceState } from './../../common/Resource';
import { ProjectDetailState } from '../state';
import { fetchAppConfigsForCurrentAppVersion } from './FetchAppConfigs';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { AppVersion } from 'data/terra/AppVersion';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';

export const SELECT_APP_VERSION = 'project/appVersions/select';

export interface SelectAppVersionAction {
  type: typeof SELECT_APP_VERSION;
  appVersion: AppVersion;
}

export const selectAppVersion = (
  appVersion: AppVersion
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: SELECT_APP_VERSION,
    appVersion,
  } as SelectAppVersionAction);
  dispatch(fetchAppConfigsForCurrentAppVersion());
};

export const selectAppVersionDelegate: DelegateMapEntry<
  SelectAppVersionAction,
  ProjectDetailState
> = {
  [SELECT_APP_VERSION]: (
    state: ProjectDetailState,
    action: SelectAppVersionAction
  ): ProjectDetailState => {
    return {
      ...state,
      selectedAppVersion: action.appVersion,
      selectedEnv: undefined,
      selectedAppConfig: undefined,
      serviceIntegrations: getInitialResourceState(),
    };
  },
};
